define('collections/customer_products',['require','collections/base','models/customer_product'],function(require){

    var BaseCollection = require('collections/base');
    var Model = require("models/customer_product");

    return BaseCollection.extend({
        model: Model,
        url: this.search ? 'customer-licenses.json?search='+ this.search :'customer-licenses.json'
    });
});

